module.exports = __webpack_public_path__ + "media/about/OverflowLogo-3bf9ff7e.png";